export default {
  lang: {
    reset: 'リセット',
    search: 'スクリーニング',
    expand: '展開',
    collapse: '収納',
  },
};
